import { Condition } from 'features/libra/sections/formLayout'
import { evaluateCondition } from 'features/libra/stepComponents/conditionalForm/conditions/evaluateConditionalFormCondition'

type FieldValuesType = Record<string, unknown>

export const getVisibleSectionIds = (
  form: ReadonlyArray<{
    sectionId: string
    showWhen: ReadonlyArray<Condition>
  }>,
  fieldValues: FieldValuesType
): ReadonlyArray<string> => {
  return form
    .filter(({ showWhen }) =>
      showWhen.every((condition) => evaluateCondition(condition, fieldValues))
    )
    .map(({ sectionId }) => sectionId)
}
